export default "__VITE_ASSET__38fcf31d__"